// Module
var code = "<footer> Copyright &copy; 2019 <a href=https://www.orehab-minds.com>OREHAB MINDS</a><br/> <ul> <li>Alle Preise zzgl. gesetzlicher MwSt.</li> </ul> </footer> ";
// Exports
module.exports = code;